/* eslint-disable */
import React from 'react';
import { connect } from 'react-redux';
import Toolbar from './calendar/Toolbar';

class CalendarToolbar extends Toolbar {
    render() {
        return (
            <div className="rbc-toolbar">
                <span className="rbc-btn-group">
                    <button
                        type="button"
                        onClick={() => this.navigate('TODAY')}
                        disabled={this.props.loading}
                    >
                        {this.props.localizer.messages.today}
                    </button>
                    <button
                        type="button"
                        onClick={() => this.navigate('PREV')}
                        disabled={this.props.loading}
                    >
                        {this.props.localizer.messages.previous}
                    </button>
                    <button
                        type="button"
                        onClick={() => this.navigate('NEXT')}
                        disabled={this.props.loading}
                    >
                        {this.props.localizer.messages.next}
                    </button>
                </span>
                <span className="rbc-toolbar-label">{this.props.label}</span>
                {!this.props.isMobile ? (
                    <span className="rbc-btn-group">
                        <button
                            type="button"
                            onClick={this.view.bind(null, 'month')}
                            disabled={this.props.loading}
                            className={
                                this.props.view == 'month' ? 'rbc-active' : null
                            }
                        >
                            {this.props.localizer.messages.month}
                        </button>
                        <button
                            type="button"
                            onClick={this.view.bind(null, 'week')}
                            disabled={this.props.loading}
                            className={
                                this.props.view == 'week' ? 'rbc-active' : null
                            }
                        >
                            {this.props.localizer.messages.week}
                        </button>
                        <button
                            type="button"
                            onClick={this.view.bind(null, 'day')}
                            disabled={this.props.loading}
                            className={
                                this.props.view == 'day' ? 'rbc-active' : null
                            }
                        >
                            {this.props.localizer.messages.day}
                        </button>
                        {this.props.views.includes('agenda') ? (
                            <button
                                type="button"
                                onClick={this.view.bind(null, 'agenda')}
                                disabled={this.props.loading}
                            >
                                Agenda
                            </button>
                        ) : null}
                    </span>
                ) : null}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.calendar.loading,
});

export default connect(mapStateToProps)(CalendarToolbar);
